module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray@2x-38b12d04bdc7937b1b4ecef6ecce3cf3.png";